import { ECurrency } from '@lbs/currency'
import { EPlayerStatus } from '@lbs/status'
import http from '../../services/http'

export interface IPlayerV2 {
  id: string
  login: string
  status: EPlayerStatus
  balance: string
  availableBalance: string
  currency: ECurrency
  gameRatio: number
}

export interface IPlayerV2Simple extends Pick<IPlayerV2, 'id' | 'login' | 'status'> {}

class PlayersV2 {
  prefix: string = '/api/v2/player'

  getPlayers = async (payload: {
    limit: number
    offset: number
  }): Promise<{
    rows: IPlayerV2[]
    count: number
  }> => {
    const response = await http.get(`${this.prefix}`, {
      params: {
        limit: payload.limit,
        offset: payload.offset,
      },
    })

    return response.data
  }

  getAllSimple = async (): Promise<{
    rows: IPlayerV2Simple[]
    count: number
  }> => {
    const response = await http.get(`${this.prefix}/simple-list`)

    return response.data
  }
}

export default new PlayersV2()
